import { Component, OnInit, signal, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';

import { ToasterService, IToasterMessage } from '../../../Services/toaster-service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-toaster-component',
  standalone: true,
  imports: [],
  templateUrl: './toaster-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./toaster-component.scss']
})
export class ToasterComponent implements OnInit, OnDestroy {
  private readonly toasterService = inject(ToasterService);
  messages = signal<IToasterMessage[]>([]);
  private subscription?: Subscription;


  ngOnInit(): void {
    this.subscription = this.toasterService.toaster$.subscribe((message: IToasterMessage) => {
      this.addMessage(message);
      this.autoRemoveMessage(message);
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private addMessage(message: IToasterMessage): void {
    this.messages.update(messages => [...messages, message]);
  }

  removeMessage(id: string): void {
    this.messages.update(messages => messages.filter(msg => msg.id !== id));
  }

  private autoRemoveMessage(message: IToasterMessage): void {
    const duration = message.duration || 3000;
    setTimeout(() => {
      this.removeMessage(message.id);
    }, duration);
  }

  getIconClass(type: string): string {
    switch (type) {
      case 'success':
        return 'icon-success';
      case 'warning':
        return 'icon-warning';
      case 'danger':
        return 'icon-danger';
      case 'info':
        return 'icon-info';
      default:
        return 'icon-info';
    }
  }
}
